// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import useProviderService from '@hooks/queries/registry/onboarding/useProviderService';
import useIsPackageAvailableFrom from '@hooks/queries/settings/useIsPackageAvailableFrom';
import React from 'react';
import { useParties } from '../../contexts/PartiesContext';
import { ActiveContractsDisableLogs } from './ActiveContractsDisableLogs';
import { AppRewardsConfigurationsPreview } from './AppRewardConfigurationsPreview';
import { CommercialAgreementsPreview } from './CommercialAgreementsPreview';
import { NetworkPolling } from './NetworkPolling';
import { WebsocketClearCache } from './WebsocketClearCache';
import { WebsocketToggle } from './WebsocketToggle';
import { VersionsPreview } from './versions/VersionsPreview';

export const AllSettings: React.FC = () => {
  const { party, operator } = useParties();
  const providerService = useProviderService();
  const isOperator = party === operator;
  const isProvider = !!providerService.data;
  const showAppRewardConfig = isOperator || isProvider;
  const enableAppRewardsConfig = useIsPackageAvailableFrom(
    'utility-registry-app-v0',
    [party, operator],
    '0.3.0',
  );
  return (
    <>
      <CommercialAgreementsPreview />
      <VersionsPreview />
      <NetworkPolling />
      <WebsocketToggle />
      <WebsocketClearCache />
      <ActiveContractsDisableLogs />
      {showAppRewardConfig && enableAppRewardsConfig.data && <AppRewardsConfigurationsPreview />}
    </>
  );
};
